// redux/reducers/designationReducer.js
import {
  FETCH_DESIGNATIONS_REQUEST,
  FETCH_DESIGNATIONS_SUCCESS,
  FETCH_DESIGNATIONS_FAILURE,
  CREATE_DESIGNATION_REQUEST,
  CREATE_DESIGNATION_SUCCESS,
  CREATE_DESIGNATION_FAILURE,
  UPDATE_DESIGNATION_REQUEST,
  UPDATE_DESIGNATION_SUCCESS,
  UPDATE_DESIGNATION_FAILURE,
  DELETE_DESIGNATION_REQUEST,
  DELETE_DESIGNATION_SUCCESS,
  DELETE_DESIGNATION_FAILURE,
} from "../actions/designationActions";

const initialState = {
  designations: [],
  loading: false,   // for fetch
  creating: false,  // for create
  updating: false,  // for update
  deleting: false,  // for delete
  error: null,
  success: false,   // optional, to show success messages
};

const designationReducer = (state = initialState, action) => {
  switch (action.type) {
    // ------------------- Fetch -------------------
    case FETCH_DESIGNATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DESIGNATIONS_SUCCESS:
      return { ...state, loading: false, designations: action.payload, error: null };
    case FETCH_DESIGNATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ------------------- Create -------------------
    case CREATE_DESIGNATION_REQUEST:
      return { ...state, creating: true, error: null, success: false };
    case CREATE_DESIGNATION_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
        designations: [...state.designations, action.payload],
        error: null,
      };
    case CREATE_DESIGNATION_FAILURE:
      return { ...state, creating: false, error: action.payload, success: false };

    // ------------------- Update -------------------
    case UPDATE_DESIGNATION_REQUEST:
      return { ...state, updating: true, error: null, success: false };
    case UPDATE_DESIGNATION_SUCCESS:
      return {
        ...state,
        updating: false,
        success: true,
        designations: state.designations.map((d) =>
          d.id === action.payload.id ? action.payload : d
        ),
        error: null,
      };
    case UPDATE_DESIGNATION_FAILURE:
      return { ...state, updating: false, error: action.payload, success: false };

    // ------------------- Delete -------------------
    case DELETE_DESIGNATION_REQUEST:
      return { ...state, deleting: true, error: null, success: false };
    case DELETE_DESIGNATION_SUCCESS:
      return {
        ...state,
        deleting: false,
        success: true,
        designations: state.designations.filter((d) => d.id !== action.payload),
        error: null,
      };
    case DELETE_DESIGNATION_FAILURE:
      return { ...state, deleting: false, error: action.payload, success: false };

    default:
      return state;
  }
};

export default designationReducer;
